import { IdLoca } from "../../utils/i18n/IdLoca";
import { TypeResource } from "../balancing/TypeResource";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdModal } from "../modals/IdModal";
export var QuickSellSwapSupportedModals = [
    IdModal.Market,
    IdModal.Cafe,
    IdModal.WaterTower,
];
export var QuickSellResourceConfig = new Map()
    .set(TypeResource.ContractsResources, {
    icon: IdIcon.ContractsMarketIcn,
    modalId: IdModal.Market,
    quickSellLoca: IdLoca.storageFull1_desc,
})
    .set(TypeResource.CafeResources, {
    icon: IdIcon.CafeIcn,
    modalId: IdModal.Cafe,
    quickSellLoca: IdLoca.storageFull1_cafe_desc,
})
    .set(TypeResource.Water, {
    icon: IdIcon.NurseryIcn,
    modalId: IdModal.Nursery,
    quickSellLoca: IdLoca.storageFull1_water_desc,
});



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-sell-dialog/QuickSellResourceConfig.ts
// module id = 856
// module chunks = 3